module.exports = __webpack_public_path__ + "img/fcfm_die_png.37245ff9.png";